interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
}

export function FormField({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = 'text',
  placeholder,
  required = false,
}: FormFieldProps) {
  const inputId = `field-${name}`;
  const errorId = `error-${name}`;

  return (
    <div className="w-full mb-4">
      <label
        htmlFor={inputId}
        className="block text-sm font-['DM_Sans',sans-serif] text-white mb-1"
      >
        {label}
        {required && <span className="text-[#f97216] ml-1">*</span>}
      </label>
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onAnimationStart={(e) => {
          if (e.animationName === 'onAutoFillStart') {
            const filled = e.currentTarget.value;
            if (filled && filled !== value) {
              onChange(filled);
            }
          }
        }}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={`w-full min-h-[44px] px-3 py-2 rounded-lg border text-base text-white font-['DM_Sans',sans-serif] placeholder-[#757575] ${
          error ? 'border-red-400' : 'border-[var(--gray-border)] focus:border-[#f97216]'
        } focus:outline-none`}
        style={{ backgroundImage: 'var(--glass-gradient)' }}
      />
      {error && (
        <p id={errorId} className="text-sm text-red-400 mt-1" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
